import _classCallCheck from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/Dropdown/dropdown';
import { css } from '@patternfly/react-styles';
export var DropdownToggleCheckbox =
/*#__PURE__*/
function (_React$Component) {
  _inherits(DropdownToggleCheckbox, _React$Component);

  function DropdownToggleCheckbox() {
    var _this;

    _classCallCheck(this, DropdownToggleCheckbox);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DropdownToggleCheckbox).apply(this, arguments));

    _this.handleChange = function (event) {
      _this.props.onChange(event.target.checked, event);
    };

    _this.calculateChecked = function () {
      var _this$props = _this.props,
          isChecked = _this$props.isChecked,
          checked = _this$props.checked;
      return isChecked !== undefined ? isChecked : checked;
    };

    return _this;
  }

  _createClass(DropdownToggleCheckbox, [{
    key: "render",
    value: function render() {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      var _a = this.props,
          className = _a.className,
          onChange = _a.onChange,
          isValid = _a.isValid,
          isDisabled = _a.isDisabled,
          isChecked = _a.isChecked,
          checked = _a.checked,
          children = _a.children,
          props = __rest(_a, ["className", "onChange", "isValid", "isDisabled", "isChecked", "checked", "children"]);

      var text = children && React.createElement("span", {
        className: css(styles.dropdownToggleText, className),
        "aria-hidden": "true",
        id: "".concat(props.id, "-text")
      }, children);
      return React.createElement("label", {
        className: css(styles.dropdownToggleCheck, className),
        htmlFor: props.id
      }, React.createElement("input", Object.assign({}, props, this.calculateChecked() !== undefined && {
        onChange: this.handleChange
      }, {
        type: "checkbox",
        ref: function ref(elem) {
          return elem && (elem.indeterminate = isChecked === null);
        },
        "aria-invalid": !isValid,
        disabled: isDisabled,
        checked: this.calculateChecked()
      })), text);
    }
  }]);

  return DropdownToggleCheckbox;
}(React.Component);
DropdownToggleCheckbox.defaultProps = {
  className: '',
  isValid: true,
  isDisabled: false,
  onChange: function onChange() {
    return undefined;
  }
};